/** @jsx jsx */
import { React } from 'react';
import { jsx } from '@emotion/core';
import { Column, Container, Row } from '../../../../styles/Grid';

import DotComponent from '../../../ui/DotComponent';
import * as Styles from './index.style';
import Spacer from '../../../ui/Spacer';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { get } from 'lodash';
import iconSvg from './icon.svg';
import ActionBlock from '../ActionBlock';

class TitleBlock extends SafePureComponent {
  render() {
    const { isDarkMode, fields } = this.props;

    const Icon = get(fields, 'Icon', '');
    const Title = get(fields, 'Title', '');
    const Introduction = get(fields, 'Introduction', '');
    return (
      <div
        className="contentsec"
        css={[
          Styles.commonCss,
          isDarkMode ? Styles.DarkModeCss : Styles.LightModeCss,
        ]}
      >
        <div className="text_sec">
          <div className="texttop">
            <span className="img_icon">
              <img src={Icon.value.src} alt="icon" />
            </span>
            <h1>
              <span>{Title.value}</span>
              <DotComponent />
            </h1>
            <p className="ptext">{Introduction.value}</p>
          </div>
          <ActionBlock isDarkMode={isDarkMode} fields={fields} />
        </div>
      </div>
    );
  }
}

export default TitleBlock;
